import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LISTING_GET_SCHEDULED_LEAD_TOURS_COUNT } from 'api/actionTypes';

export default async function getScheduledLeadToursCount(
  { state, apiClient },
  { listingId, forceRefresh = false },
) {
  typeCheck('listingId::PositiveNumber', listingId);

  const statePath = ['scheduledLeadToursCountByListingId', listingId];
  if (state.exists(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  const result = await apiClient.postWithState({
    action: SR_API_ACTION_LISTING_GET_SCHEDULED_LEAD_TOURS_COUNT,
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(scheduledLeadToursCount) {
      state.set(statePath, scheduledLeadToursCount);
    },
  });

  return result;
}
